module.exports = __webpack_public_path__ + "img/0160_japanese-paper_00012.ac7fb679.jpg";